import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';

let entryPoint: HTMLElement;

const initApp = (): void => {
  const root = createRoot(entryPoint);
  root.render(React.createElement(App));
};

const init = (): void => {
  entryPoint = document.querySelector('.where-to-buy-entry');

  if (entryPoint) {
    initApp();
  }
};

export default {
  init,
};
